var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCableCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58692 9.03646C4.9776 9.03646 4.48364 9.53041 4.48364 10.1397V18.1561C4.48364 18.7654 4.9776 19.2594 5.58692 19.2594H18.4131C19.0224 19.2594 19.5164 18.7654 19.5164 18.1561V10.1397C19.5164 9.53041 19.0224 9.03646 18.4131 9.03646H5.58692ZM3.48364 10.1397C3.48364 8.97812 4.42531 8.03646 5.58692 8.03646H18.4131C19.5747 8.03646 20.5164 8.97812 20.5164 10.1397V18.1561C20.5164 19.3177 19.5747 20.2594 18.4131 20.2594H5.58692C4.42531 20.2594 3.48364 19.3177 3.48364 18.1561V10.1397Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13016 15.8488L8.13016 8.73816L9.13016 8.73816L9.13016 15.8488L8.13016 15.8488Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2065 15.8488L14.2065 8.73816L15.2065 8.73816L15.2065 15.8488L14.2065 15.8488Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7506 16.6729L4.11838 16.6729L4.11838 15.6729L19.7506 15.6729L19.7506 16.6729Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7505 4.24063L4.2494 5.86987L4.14487 4.87535L19.646 3.24611L19.7505 4.24063Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1737 8.73816L11.1737 4.24063L12.1737 4.24063L12.1737 8.73816L11.1737 8.73816Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableCar);
export default __webpack_public_path__ + "static/media/cable_car.32249a01252189e9e2bf2f1df1fbedcd.svg";
export { ForwardRef as ReactComponent };